export default {
  Sms: 'SMS',
  Email: 'EMAIL',
  Password: 'PASSWORD',
};
